import {deviceStore} from "../../../redux/device/deviceStore";

export const useDebugDeviceMockLogic = () => {
  return {
    handleClickMockIPhone: () => deviceStore.setDeviceAsMobileIPhone(),
    handleClickMockIPad: () => deviceStore.setDeviceAsTabletIPad(),
    handleClickMockWindowsDesktop: () => deviceStore.setDeviceAsDesktopWindows(),
    handleClickMockMacDesktop: () => deviceStore.setDeviceAsDesktopMac(),
    handleClickMockAndroid: () => deviceStore.setDeviceAsAndroid(),
  };
}
